import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import CardGroup from './components/CardGroup';
import { useAiContext } from './context/AiContext';
import ExerciseView from './views/ExerciseView';
import TrainingPlanView from './views/TrainingPlanView';
import WorkoutsView from './views/WorkoutsView';
const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 50px)',
    marginTop: '50px',
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  chatInput: {
    backgroundColor: '#303030',
    borderRadius: 12,
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      color: '#ccc',
      paddingRight: 8,
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 12px',
    },
  },
}));

const AiAgent = ({ open }) => {
  const classes = useStyles();

  const { selectedType } = useAiContext();

  return (
    <main
      className={clsx(classes.content, {
        [classes.contentShift]: open,
      })}
    >
      <div
        style={{
          backgroundColor: '#212121',
          padding: '16px',
          borderRadius: 8,
          flexShrink: 0,
        }}
      >
        <CardGroup />
      </div>
      {selectedType === 'exercises' && <ExerciseView open={open} />}
      {selectedType === 'workouts' && <WorkoutsView classes={classes} />}
      {selectedType === 'training-plan' && <TrainingPlanView classes={classes} />}
    </main>
  );
};

export default AiAgent;
